exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var getUrl = require("../../../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL___0___ = getUrl(require("../fonts/Inter-Regular.woff2"));
var ___CSS_LOADER_URL___1___ = getUrl(require("../fonts/Inter-Regular.woff"));
// Module
exports.push([module.id, "@font-face {\n    font-family: 'Inter-Regular';\n    src: url(" + ___CSS_LOADER_URL___0___ + ") format('woff2'), url(" + ___CSS_LOADER_URL___1___ + ") format('woff');\n    font-weight: 400;\n    font-style: normal;\n}\n", ""]);
